import React from "react";
import { useSelector, useDispatch } from "react-redux";

import { Autocomplete, FormControl, TextField } from "@mui/material";
import { SCHEDULE_TYPE_PAYLOAD_MAPPER } from "static/constants";
import { changeFilter } from "app/store/dashboard/billable_interval_analytic/slice/billableIntervalAnalyticSlice";
import { KeyboardArrowDown } from "@mui/icons-material";

const inputStyle = {
  ".MuiInputBase-root": {
    background: "transparent",
    marginRight: "10px",
    maxWidth: "160px",
    padding: "2px 6px !important",
  },
  ".MuiFormLabel-root": {
    color: "#94BA33",
  },
  ".MuiInputBase-input": {
    color: "#94BA33",
    fontSize: "0.875rem",
    fontWeight: 500,
    padding: "4px 8px",
    backgroundColor: "transparent",
    height: "30px !important",
  },

  "&:focus": {
    background: "transparent !important",
  },
  ".MuiSvgIcon-root": {
    color: "#94BA33",
  },
  "& .MuiInputLabel-root": {
    color: "#94BA33",
  },
  "& .MuiInputLabel-root.Mui-focused": {
    color: "#94BA33",
  },
  ".MuiOutlinedInput-input": {
    fontSize: "12px",
  },
};

const BillableIntervalAnalyticIntervalFilter = () => {
  const dispatch = useDispatch();
  const { interval } = useSelector((state) => state.billableIntervalAnalytic);

  const options = Object.entries(SCHEDULE_TYPE_PAYLOAD_MAPPER).map(
    ([key, value]) => ({
      label: key,
      value,
    })
  );

  return (
    <FormControl
      sx={{ minWidth: "100px", marginRight: "10px", marginTop: "12px" }}
    >
      <Autocomplete
        value={options.find((opt) => opt.value === interval) || null}
        options={options}
        popupIcon={<KeyboardArrowDown sx={{ color: "#94BA33" }} />}
        onChange={(_event, newValue) => {
          dispatch(
            changeFilter({
              type: "interval",
              value: newValue ? newValue?.value : null, // Handle clear
            })
          );
        }}
        variant="outlined"
        getOptionLabel={(option) => option?.label}
        displayEmpty
        renderInput={(params) => (
          <TextField
            {...params}
            required
            label="Interval"
            variant="outlined"
            margin="none"
            size="small"
            sx={inputStyle}
          />
        )}
      />
    </FormControl>
  );
};

export default BillableIntervalAnalyticIntervalFilter;
